module.exports = __webpack_public_path__ + "img/aboutUs.4d9b91a7.jpg";